export default {
    baseStyle: {
        container: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: 'white'
        },
        headerWrapper: {
            position: 'sticky',
            top: 0,
            zIndex: '1350!important'
        }
    },
    parts: ['container']
}
